import React from "react";
import { Tooltip } from "@mui/material";

const DSTooltip = (props: React.ComponentProps<typeof Tooltip>) => {
  return <Tooltip {...props} />;
};

export default DSTooltip;
